import { localStorageKeys } from "@/enums/common";

const initialState = () => {
  return {
    user: JSON.parse(localStorage.getItem(localStorageKeys.heybooster))?.user || {},
    userPremiumPlanInformation: {
      status: false,
      startDate: null,
      endDate: null,
      isSubscriptionCanceled: false
    },
    isUserPremium: false,
    isClientPremium: null,
    billing: {},
    accountClients: [],
  }
}

export default initialState;



// WEBPACK FOOTER //
// ./src/store/modules/auth/initialState.js